import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import styles from './FeaturePopupContent.module.scss';
import { FEATURE_TYPES } from '../../../../lib/constants';
import { prettyNumber, metersToMiles, squareMetersToAcres, metersToFeet } from '../../../../lib/utils';
import get from 'lodash-es/get';

function FeaturePopupContent(props) {
  const { feature, hideCoords } = props; 

  const getFeatureData = (attributes) => {
    switch (attributes.properties.ghType) {
      case(FEATURE_TYPES.Point):
        return (
          <>
            <p className={styles.attributeRow}>
              <span className={styles.highlight}>Location </span>
              {hideCoords ? '--' : attributes.geometry.coordinates[1].toFixed(4)}, {hideCoords ? '--' : attributes.geometry.coordinates[0].toFixed(4)}
            </p>
            <p className={styles.attributeRow}>
              <span className={styles.highlight}>Elevation </span>
              {hideCoords ? '--' : prettyNumber(metersToFeet(attributes.geometry.coordinates[2]), 0)} ft
            </p>
          </>
        );
      case(FEATURE_TYPES.Tracks):
      case(FEATURE_TYPES.Polyline):
        return (
          <p className={styles.attributeRow}>
            <span className={styles.highlight}>Length </span>
            {prettyNumber(metersToMiles(attributes.properties.distance))} miles
          </p>
        );
      case(FEATURE_TYPES.Polygon):
        return (
          <p className={styles.attributeRow}>
            <span className={styles.highlight}>Area </span>
            {prettyNumber(squareMetersToAcres(attributes.properties.area), 0)} acres
          </p>
        );
      default:
        return '';
    }
  };

  return (
    <div className={ styles.popupContent }>
      {/* ${attributes.photos && attributes.photos.length > 0 ? <img src="" /> : null} */}
      { getFeatureData(feature) }
      <p className={styles.updated}>Created: {dayjs.unix(feature.properties.createdAt).format('MM/DD/YYYY h:mm a')}</p>
      <p className={styles.updated}>Updated: {dayjs.unix(feature.properties.updatedAt).format('MM/DD/YYYY h:mm a')}</p>
      <p className={styles.collectionCount}>In {get(feature, ['collectionIds', 'length'], 0)} hunts</p>
    </div>
  );
}

FeaturePopupContent.propTypes = {
  feature: PropTypes.object,
  hideCoords: PropTypes.bool
};

export default FeaturePopupContent;